/**
 * 購入完了画面のグロッサリIDの型定義
 *
 * IDの先頭5桁（GL00x）は同一ファイル内では同じものを使用し、グロッサリファイル間では一意とする。
 * それ以降の5桁はファイル内でIDが被らないように採番する。
 */
export const CompletionGL = {
  /** ご購入ありがとうございました */
  ThankPurchase: 'GL00800001',
  /** プラン一覧に戻る */
  ToPlanList: 'GL00800002',
  /** プランの管理(COMMON_0015) */
  ToContractList: 'GL00800003',
  /** ログアウトして終了 */
  ToLogout: 'GL00800004',
  /** 解約手続きを完了しました。ご利用ありがとうございました。 */
  ThankDelete: 'GL00800005',
  /** プランを購入者へ返却しました。ご利用ありがとうございました。 */
  ThankReturn: 'GL00800006'
} as const;
export type CompletionGLKeys = typeof CompletionGL[keyof typeof CompletionGL];
